import { RouteObject } from "react-router-dom";
import ConfigurationPage from "../page/configuration.page";

export const ConfigurationRoute: RouteObject = {
  path: "/settings-and-configurables/configurable",
  element: (
      <ConfigurationPage />
  ),
};